import { Slot } from '@bnnvara/slot/src/component/Slot';
import { withSlot } from '@bnnvara/slot/src/hoc/withSlot';
import PropTypes from 'prop-types';
import React from 'react';
import { ImageCard } from '../ImageCard/ImageCard';
import * as S from './styled';
export const ImageWithTextCard = withSlot(({
  image,
  content
}) => {
  return /*#__PURE__*/React.createElement(S.Container, null, /*#__PURE__*/React.createElement(ImageCard, {
    src: image.src,
    alt: image.alt,
    isLazyLoaded: image.isLazyLoaded
  }, /*#__PURE__*/React.createElement(Slot, {
    name: "image",
    content: content
  })), /*#__PURE__*/React.createElement(S.Text, null, /*#__PURE__*/React.createElement(Slot, {
    name: "text",
    content: content
  })));
});
ImageWithTextCard.propTypes = {
  image: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    isLazyLoaded: PropTypes.bool,
    src: PropTypes.string.isRequired
  }),
  content: PropTypes.node
};